import { useCurrentFrame, interpolate } from 'remotion';

const KIND_COLORS = {
  method:   '#B180D7',
  property: '#4EC9B0',
  class:    '#E8AB53',
  keyword:  '#569CD6',
  variable: '#9CDCFE',
};

function ItemIcon({ kind }) {
  const color = KIND_COLORS[kind] || '#858585';
  return (
    <span style={{
      display: 'inline-block',
      width: 10, height: 10,
      background: color,
      borderRadius: kind === 'method' ? '50%' : 2,
      flexShrink: 0,
      marginRight: 6,
    }}/>
  );
}

/**
 * IntelliSense autocomplete popup — VS 2022 dark theme.
 * Props:
 *   items: [{ label, kind, detail }]
 *   selectedIndex: number
 *   visible: boolean
 *   x: number (pixel x)
 *   y: number (pixel y)
 *   appearFrame: number (frame when popup appeared, for fade-in)
 */
export default function IntelliSensePopup({ items = [], selectedIndex = 0, visible, x = 0, y = 0, appearFrame = 0 }) {
  const frame = useCurrentFrame();
  if (!visible || items.length === 0) return null;

  const opacity = interpolate(frame - appearFrame, [0, 4], [0, 1], { extrapolateRight: 'clamp' });
  const visibleItems = items.slice(0, 8);

  return (
    <div style={{
      position: 'absolute',
      left: x,
      top: y,
      width: 280,
      background: '#252526',
      border: '1px solid #454545',
      boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
      zIndex: 100,
      opacity,
      fontFamily: "'Cascadia Code','Consolas','Courier New',monospace",
      fontSize: 12,
      userSelect: 'none',
    }}>
      {visibleItems.map((item, i) => (
        <div key={i} style={{
          display: 'flex',
          alignItems: 'center',
          height: 22,
          paddingLeft: 6,
          paddingRight: 8,
          background: i === selectedIndex ? '#094771' : 'transparent',
          color: '#D4D4D4',
          overflow: 'hidden',
        }}>
          <ItemIcon kind={item.kind}/>
          <span style={{ flex: '0 0 auto', marginRight: 8 }}>{item.label}</span>
          <span style={{
            color: '#858585',
            fontSize: 11,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            flex: 1,
          }}>{item.detail}</span>
        </div>
      ))}
    </div>
  );
}
